import { Route } from 'react-router-dom';
import { LegalNoticesPage } from './pages/LegalNoticesPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';

export const legalRoutes = (
  <>
    <Route path="/legal/terms" element={<TermsOfServicePage />} />
    <Route path="/legal/privacy" element={<PrivacyPolicyPage />} />
    <Route path="/legal/notices" element={<LegalNoticesPage />} />
  </>
);
